export default {
  form: {
    type: 'static', // 'static' or 'dynamic'
    questions: [],
    media: [],
    scoring: [],
    styles: {},
  },
  selectedQuestion: {
    id: null,
    vuexId: null,
  },
  // Dynamic forms only (non-static)
  screens: [
    {
      number: 1,
      questionVuexId: null,
      layout: { type: 'text-only' },
    },
  ],
  currentScreen: 1,
  // Dynamic forms logic warnings state - Shown to warn users logic or scores need to be checked when editing a form
  logicWarningsShown: {
    addQuestionOptions: false,
    reorderQuestions: false,
    deleteQuestion: false,
    addQuestion: false,
    reorderQuestionOptions: false,
  },
  layoutVideoSources: window.__RMP_EVENTS_VIDEO_SOURCES_FOR_QUESTION_LAYOUTS__, // eslint-disable-line
};
